<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Login v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">


          <h2 class="brand-text text-primary ml-1">
            Scarsdale Sims
          </h2>
        </b-link>

        <b-card-title class="mb-1">
          Welcome! 👋
        </b-card-title>
        <b-card-text class="mb-2">
          Please sign-in to your account
        </b-card-text>

        <!-- form -->
        <validation-observer
          ref="loginForm"
          #default="{invalid}"
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="login"
          >

            <!-- email -->
            <b-form-group
              label-for="user"
              label="Sedona Username"
            >
              <validation-provider
                #default="{ errors }"
                name="Username"
                vid="username"
                rules="required"
              >
                <b-form-input
                  id="user"
                  v-model="username"
                  name="login-user"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Username"
                  autofocus
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Password"
                vid="password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false:null"
                    name="login-password"
                    placeholder="Password"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- checkbox -->
            <b-form-group>
              <b-form-checkbox
                id="remember-me"
                v-model="status"
                name="checkbox-1"
              >
                Remember Me
              </b-form-checkbox>
            </b-form-group>

            <!-- submit button -->
            <b-button
              variant="primary"
              type="submit"
              block
              :disabled="invalid"
            >
              Sign in
            </b-button>
          </b-form>
        </validation-observer>
      </b-card>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {required, email} from '@validations'
import {togglePasswordVisibility} from '@core/mixins/ui/forms'
import store from "@/store";
import useJwt from "@/auth/jwt/useJwt";
import {getHomeRouteForLoggedInUser} from "@/auth/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import Echo from "laravel-echo";

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      username: '',
      password: '',
      status: '',
      // validation rules
      required,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    login() {
      var self = this;
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          useJwt
            .login({
              username: this.username,
              password: this.password,
            })
            .then(response => {
              console.log('login response', response);
              const {userData, accessToken, refreshToken} = response.data
              useJwt.setToken(accessToken)
              useJwt.setRefreshToken(refreshToken)
              localStorage.setItem('userData', JSON.stringify(userData))
              self.$ability.update(userData.ability)

              window.Echo = new Echo({
                broadcaster: 'pusher',
                key: process.env.MIX_PUSHER_APP_KEY,
                cluster: process.env.MIX_PUSHER_APP_CLUSTER,
                wsHost: window.location.hostname,
                authEndpoint: '/broadcasting/auth',
                encrypted: false,
                forceTLS: false,
                wsPort: 6001,
                wssPort: process.env.MIX_PUSHER_APP_PORT,
                disableStats: true,
                enabledTransports: ['ws', 'wss'],
                auth: {
                  headers: {
                    authorization: 'Bearer ' + accessToken,
                  }
                }
              });

              window.Echo.connector.pusher.connection.bind('connected', () => {
                console.log('connected');
                store.commit('app/UPDATE_ECHO_STATUS', 'connected');
              });

              window.Echo.connector.pusher.connection.bind('state_change', (states) => {
                console.log('state change', states.previous, states.current);
                store.commit('app/UPDATE_ECHO_STATUS', states.current);
              });

              // ? This is just for demo purpose as well.
              // ? Because we are showing eCommerce app's cart items count in navbar
              // this.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', userData.extras.eCommerceCartItemsCount)

              // ? This is just for demo purpose. Don't think CASL is role based in this case, we used role in if condition just for ease
              this.$router.replace(getHomeRouteForLoggedInUser(userData.role)).then(() => {

              })
            })
            .
              catch(error => {
                console.log(error);
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: `Your login did not work`,
                    icon: 'CoffeeIcon',
                    variant: 'danger',
                    text: `Your login has failed - please try pressing login once more if you are new user.`,
                  },
                })
                this.$refs.loginForm.setErrors(error.response.data.error)
              })
            }
        }
      )
      },
    },
  }
</script>

<style lang="scss">
@import '~@resources/scss/vue/pages/page-auth.scss';
</style>
